import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SectionType } from 'enums-lib';
import { IMultiselectListItem } from 'multi-select-autocomplete-lib';
import { SectionComponentBase } from '../../../sections/section-component-base';

@Component({
  selector: 'app-docmerge-section-list',
  templateUrl: './docmerge-section-list.component.html',
  styleUrls: ['./docmerge-section-list.component.scss'],
  standalone: false,
})
export class DocmergeSectionListComponent extends SectionComponentBase {
  @Input() set expandedSectionIndex(expandedSectionIndex) {
    this._expandedSectionIndex = expandedSectionIndex;
    if (expandedSectionIndex !== null) {
      setTimeout(() => this.scrollToSection(expandedSectionIndex));
    }
  }
  @Input() workflowConfigId: string;
  @Input() sections: FormGroup[] = [];
  @Input() entityType = '';
  @Input() namespace = '';
  @Input() allCertifications: IMultiselectListItem[] | undefined = undefined;
  @Input() allCertificationGroups: IMultiselectListItem[] | undefined = undefined;
  @Input() combinedOutput = false;
  @Output() removeSection = new EventEmitter<number>();
  @Output() reorderSections = new EventEmitter<{ previousIndex: number; currentIndex: number }>();

  _expandedSectionIndex: number | null = null;

  protected readonly SectionType = SectionType;

  getSectionType(section: FormGroup): string {
    return section.get('type')?.value || '';
  }

  getSectionIcon(sectionType: string): string {
    switch (sectionType) {
      case SectionType.DocMergeTemplateSection:
        return 'widgets';
      case SectionType.Merge:
        return 'description';
      case SectionType.File:
        return 'home_storage';
      case SectionType.FixedFile:
        return 'insert_drive_file';
      case SectionType.Certification:
        return 'workspace_premium';
      default:
        return 'settings';
    }
  }

  getSectionLabel(sectionType: string): string {
    switch (sectionType) {
      case SectionType.Merge:
      case SectionType.DocMergeTemplateSection:
        return 'Template section';
      case SectionType.File:
        return 'File section';
      case SectionType.FixedFile:
        return 'Fixed section';
      case SectionType.Certification:
        return 'Certification section';
      default:
        return 'Section';
    }
  }

  getSectionSubtitle(section: FormGroup): string {
    return section.get('displayName')?.value || 'Untitled Section';
  }

  onRemoveSection(index: number): void {
    this.removeSection.emit(index);
  }

  isExpanded(index: number): boolean {
    return this._expandedSectionIndex === index;
  }

  getEntityType(): string {
    return this.entityType;
  }

  getNamespace(): string {
    return this.namespace;
  }

  onSectionReorder(event: CdkDragDrop<FormGroup[]>): void {
    console.log('Reorder event:', event);
    if (event.previousIndex !== event.currentIndex) {
      this.reorderSections.emit({
        previousIndex: event.previousIndex,
        currentIndex: event.currentIndex,
      });
    }
  }

  scrollToSection(index: number) {
    const el = document.getElementById('section-' + index);
    el?.scrollIntoView({ behavior: 'smooth' });
  }
}
